exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  box-sizing: border-box;\n}\n\n/* Style the search field */\nform.example input[type=text] {\n  padding: 10px;\n  font-size: 17px;\n  border: 1px solid grey;\n  float: left;\n  width: 80%;\n  background: #f1f1f1;\n}\n\n/* Style the submit button */\nform.example button {\n  float: left;\n  width: 20%;\n  padding: 10px;\n  background: #2196F3;\n  color: white;\n  font-size: 17px;\n  border: 1px solid grey;\n  border-left: none;\n  /* Prevent double borders */\n  cursor: pointer;\n}\n\nform.example button:hover {\n  background: #0b7dda;\n}\n\n/* Clear floats */\nform.example::after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/reversecharge-edit/reversecharge-edit.component.css
// module id = ../../../../../src/app/shared/component/reversecharge-edit/reversecharge-edit.component.css
// module chunks = main